















import { Component, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import PageError from '@/pages/404.vue';
import {
  ModuleMain,
  ModuleLayout,
  ModuleFooter,
  ModuleButton,
  ModuleSidebar,
} from '@/components/parts/modules';
import breadcrumbsMixin from '../mixins/breadcrumbs-mixin';
import isAuthorizedMixin from '@/mixins/isAuthorized';
import createStoreModule from './store';
import { Context } from './types';
import { STORE_MODULE_NAME, FETCH_ITEM } from './consts';
import { StateModuleMixin } from '@/services';

const Module = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [FETCH_ITEM]);
const fetch = actions[FETCH_ITEM];

@Component({
  components: {
    PageError,
    ModuleMain,
    ModuleButton,
    ModuleLayout,
    ModuleFooter,
    ModuleSidebar,
    BreadcrumbsLayout,
  },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  metaInfo(): MetaInfo {
    const { main } = this.$store.state.module;
    return {
      title: (main && main.name) || '',
    };
  },
})
export default class ModuleCard extends Mixins(
  breadcrumbsMixin,
  StateModuleMixin,
  isAuthorizedMixin
) {
  @Module.State id: any;
  @Module.State main: any;
  @Module.State footer: any;
  @Module.State sidebar: any;
  @Module.State professionId: any;
  @Module.State nothingFound: boolean;

  isModuleInBasket = false;

  get crumbs() {
    const { main, breadcrumbs } = this;
    if (!main || !main.name) return breadcrumbs;
    return breadcrumbs.concat([{ text: main.name }]);
  }

  get isPublishedConstructor() {
    const { main } = this;
    return main.isPublishedConstructor;
  }

  get moduleDataAddToBasket() {
    const {
      id,
      professionId,
      main: { name, weeks },
      sidebar: { cost, competences, formEducationId, studentCategories },
    } = this;
    return {
      id,
      cost,
      weeks,
      title: name,
      competences,
      professionId,
      formEducationId,
      studentCategories,
    };
  }

  get isModuleSaved() {
    return this.saved(this.moduleDataAddToBasket);
  }

  addOrRemoveToBasket() {
    const { moduleDataAddToBasket, isModuleSaved } = this;
    this.toggle(moduleDataAddToBasket, isModuleSaved);
  }

  async asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const params = {
      ...route.query,
      ...route.params,
    };

    const result = await fetch.call(context, params.id);
    return result;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/modules/card/ModuleCard.vue